module.exports = __webpack_public_path__ + "static/media/slider-6.34bc0e51.jpg";